import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { shareReplay, type Observable } from 'rxjs';
import { X_REAL_IP } from '@common/tokens';

type GeoIpResponse = {
    organization: string;
    region: string;
    asn: number;
    ip: string;
    timezone: string;
    longitude: number;
    postal_code: string;
    city: string;
    continent_code: string;
    country: string;
    region_code: string;
    country_code: string;
    latitude: number;
};
@Injectable({
    providedIn: 'root',
})
export class CountryISOService extends BaseHttpService {
    private readonly xRealIp = inject(X_REAL_IP, { optional: true });
    private cachedRequest: Observable<unknown>;

    public getCountryISO(): Observable<any> {
        if (!this.cachedRequest) {
            this.cachedRequest = this.http
                .get(`https://geoip.sendpulse.com${this.xRealIp ? '/' + this.xRealIp : ''}`)
                .pipe(shareReplay(1));
        }
        return this.cachedRequest;
    }
}
